var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', _vm._g(_vm._b({
    attrs: {
      "content-class": "fill-height",
      "persistent": "",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "value": true
    }
  }, 'dialog-scroll-lock', _vm.$attrs, false), _vm.$listeners), [_c('v-card', {
    staticClass: "fill-height d-flex flex-column"
  }, [_c('div', {
    staticClass: "flex-grow-0 pa-1 grey lighten-4 d-sm-flex flex-row-reverse flex-wrap align-center"
  }, [_c('div', {
    staticClass: "pa-2 flex-grow-1 d-flex justify-end"
  }, [_c('div', {
    staticClass: "mr-3 btn-group btn-group-horizontal"
  }, [_c('v-btn', {
    on: {
      "click": _vm.selectAll
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiSelectGroup)
    }
  }), _c('span', {
    staticClass: "ml-2 hidden-xs-only"
  }, [_vm._v("Select all")])], 1), _c('v-btn', {
    attrs: {
      "disabled": !_vm.staged.length
    },
    on: {
      "click": function ($event) {
        _vm.staged = [];
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiSelectRemove)
    }
  }), _c('span', {
    staticClass: "ml-2 hidden-xs-only"
  }, [_vm._v("Clear selection")])], 1)], 1), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.done
    }
  }, [_vm._v("Done")])], 1), _c('div', {
    staticClass: "pl-4 pl-md-2 pr-2 py-2 text-right text-sm-left",
    class: {
      'error--text': !_vm.staged.length
    }
  }, [_c('div', {
    staticClass: "text--label-active",
    class: {
      'error--text': _vm.error
    }
  }, [_vm._v(" " + _vm._s(_vm._f("pl")(_vm.staged.length, 'design')) + " selected (limit " + _vm._s(_vm.limit) + ") ")])])]), _c('v-divider', {
    staticClass: "flex-grow-0"
  }), _c('catalog-category', {
    ref: "catalog",
    staticClass: "flex-grow-1",
    attrs: {
      "embedded": "",
      "hide-header": "",
      "hide-background": "",
      "breadcrumbs": _vm.categories,
      "category": _vm.categories.last,
      "highlight": _vm.stagedDesignIds
    },
    on: {
      "click:category": function (v) {
        _vm.categories = _vm.categories.includes(v) ? _vm.categories.slice(0, _vm.categories.indexOf(v) + 1) : [].concat(_vm.categories, [v]);
      },
      "select": _vm.toggle
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }